// @ts-nocheck
import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Box,
  Button,
  Chip,
  Divider,
  List,
  ListItem,
  styled,
  ListItemButton,
  ListItemIcon
} from '@mui/material';
import {
  Menu as MenuIcon,
  KeyboardArrowDown,
  Sync as SyncIcon,
  ExitToApp as LogoutIcon,
  VpnKey as PasswordIcon,
  Lock as LockIcon,
  Person as PersonIcon,
  MoreVert as MoreVertIcon
} from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { useGetUserInfoMutation } from '../pages/settings/services/user';
import { setCurrentUserState } from '../store/slices/currentUserState';
import { useRouter } from '../hooks/use-router';
import { isLoginFunc } from '../store/slices/login';
import { useSnackbar } from 'notistack';
import { globalVal } from '../utils/global-values';
import { useLogoutMutation } from '../pages/login/services/authenticationApi';
import { clearPermissionCache } from '../hooks/usePermission';
import { clearTableStateStorage } from '../utils/clear-table-state-storage';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  boxShadow: '0 2px 4px rgba(0,0,0,0.04) !important' // Daha az belirgin bir gölge
}));

const StyledChip = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.success.light,
  color: theme.palette.success.main,
  padding: '0 12px',
  height: '24px',
  borderRadius: '15px',
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: '0.75rem',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: 'rgba(82, 196, 26, 0.2)'
  }
}));

interface HeaderProps {
  onDrawerToggle: () => void;
  drawerOpen: boolean;
}

const Header: React.FC<HeaderProps> = ({ onDrawerToggle, drawerOpen }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { isAuthenticated } = useSelector((state: RootState) => state.login);
  const { currentUserState } = useSelector((state: RootState) => state.currentUserState);

  const location = useLocation();
  const theme = useTheme();
  const [companyMenuAnchor, setCompanyMenuAnchor] = useState<null | HTMLElement>(null);
  const [userMenuAnchor, setUserMenuAnchor] = useState<null | HTMLElement>(null);
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState<null | HTMLElement>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const [getUserInfo, { isLoading }] = useGetUserInfoMutation();
  const dispatch = useDispatch();
  const router = useRouter();
  const [logout] = useLogoutMutation();

  const checkCurrentUser = async () => {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser && JSON.parse(currentUser)) {
      //  currentUser?.find(user => user.selectedUserInfo === 1)?.companyId;
      const parsedUser = JSON.parse(currentUser);
      return parsedUser;
    } else {
      const response = await getUserInfo();
      if (response?.data && Array.isArray(response.data)) {
        // Eğer tek bir kurum varsa, onu otomatik seçili yap
        let userData = response.data;
        if (userData.length === 1) {
          userData = [{ ...userData[0], selectedUserInfo: 1 }];
        }
        localStorage.setItem('currentUser', JSON.stringify(userData));
        return userData;
      }
    }
  }

  const [users, setUsers] = useState(null);
  const [selectedCompanyId, setSelectedCompanyId] = useState<number | null>(null);
  //const [currentUserState, setCurrentUserState] = useState<any>(null);

  useEffect(() => {
    const fetchUsers = async () => {
      const response = await checkCurrentUser();
      if (response?.length > 0) {
        const selectedUser = response?.find(user => user.selectedUserInfo === 1);
        setSelectedCompanyId(selectedUser?.companyId);
        // setCurrentUserState(selectedUser);
        dispatch(setCurrentUserState(selectedUser))
        setUsers(response);
      }
    };
    if (isAuthenticated)
      fetchUsers();
  }, [isAuthenticated]);


  if (!isAuthenticated || isLoading) return null;

  const handleCompanySwitch = async (companyId: number) => {
    setUserMenuAnchor(null);
    const updatedUsers = users?.map(user => ({
      ...user,
      selectedUserInfo: user.companyId === companyId ? 1 : 0
    }));
    localStorage.setItem('currentUser', JSON.stringify(updatedUsers));

    // Update the local users state to reflect the changes in UI
    setUsers(updatedUsers);
    setSelectedCompanyId(companyId);

    try {
      const selectedUser = updatedUsers?.find(user => user.companyId === companyId);
      dispatch(setCurrentUserState(selectedUser))
    } catch (error) {
      enqueueSnackbar('Kullanıcı seçimi güncellenirken hata oluştu.', { variant: 'error' });
    }
    // Kurum değişince tüm tablo filtre/sıralama/selection state'lerini sıfırla
    clearTableStateStorage();
  };

  const handleSignOut = async () => {
    try {
 
      const response = await logout().unwrap();

      if (response?.success) {
        clearPermissionCache();
        globalVal.isLoggedOut = true;
        dispatch(isLoginFunc(false));
        localStorage.clear();
        setUserMenuAnchor(null);
        setCompanyMenuAnchor(null);
        router.push("/login");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    clearPermissionCache();
    globalVal.isLoggedOut = true;
    dispatch(isLoginFunc(false));
    localStorage.clear();
    navigate('/login', { replace: true });
    handleClose();
  };

  return (
    <StyledAppBar
      position="fixed"
      sx={{
        width: drawerOpen ? `calc(100% - 250px)` : '100%',
        ml: drawerOpen ? '250px' : 0,
        transition: 'width 0.3s, margin-left 0.3s',
        boxShadow: theme.shadows[1],
      }}
    >
      <Toolbar>
        {!drawerOpen && (
          <AnimatePresence mode='wait'>
            <motion.div
              key="menu"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.5 }}
              transition={{ duration: 0.3 }}
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={onDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            </motion.div>
          </AnimatePresence>
        )}
        {/* Desktop - Company Selector */}
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end', mr: 2 }}>
          <Button
            onClick={(e) => setCompanyMenuAnchor(e.currentTarget)}
            sx={{
              borderRadius: 2,
              px: 1.5,
              py: 0.8,
              textTransform: 'none',
              backgroundColor: 'rgba(0, 0, 0, 0.02)',
              border: '1px solid rgba(0, 0, 0, 0.08)',
              minWidth: 160,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                border: '1px solid rgba(0, 0, 0, 0.12)',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
              },
              transition: 'all 0.2s ease-in-out'
            }}
            startIcon={
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  boxShadow: '0 2px 8px rgba(46, 82, 152, 0.3)'
                }}
              >
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
                </svg>
              </Box>
            }
            endIcon={
              <KeyboardArrowDown
                sx={{
                  transition: 'transform 0.2s ease-in-out',
                  transform: Boolean(companyMenuAnchor) ? 'rotate(180deg)' : 'rotate(0deg)',
                  color: 'text.secondary'
                }}
              />
            }
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 1, flex: 1 }}>
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  fontSize: '0.6rem',
                  lineHeight: 1,
                  mb: 0.1
                }}
              >
                Kurum
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  color: 'text.primary',
                  fontWeight: 500,
                  lineHeight: 1.2,
                  textAlign: 'left',
                  wordWrap: 'break-word',
                  hyphens: 'auto',
                  fontSize: '0.8rem'
                }}
              >
                {currentUserState?.companyName}
              </Typography>
            </Box>
          </Button>

          <Menu
            anchorEl={companyMenuAnchor}
            open={Boolean(companyMenuAnchor)}
            onClose={() => setCompanyMenuAnchor(null)}
            sx={{
              zIndex: 10000000,
            }}
            PaperProps={{
              sx: {
                width: { xs: 240, sm: 280, md: 320 },
                borderRadius: 2,
                boxShadow: '0 6px 24px rgba(0, 0, 0, 0.10)',
                border: '1px solid rgba(0, 0, 0, 0.08)',
                overflow: 'hidden',
              }
            }}
            MenuListProps={{
              sx: {
                padding: 0
              }
            }}
          >
            {/* Header with fintech gradient background */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white',
                p: 1.5,
                zIndex: 10000000,
                position: 'relative',
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'white', fontSize: '0.85rem' }}>
                Kurumlar
              </Typography>
              <Box
                sx={{
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.75rem',
                  fontWeight: 'bold',
                  backdropFilter: 'blur(10px)'
                }}
              >
                {users?.length}
              </Box>
            </Box>

            {/* Companies List */}
            <Box sx={{ p: 1.5, maxHeight: 280, overflow: 'auto' }}>
              {users?.map((user) => (
                <Box
                  key={user.companyId}
                  onClick={() => {
                    handleCompanySwitch(user.companyId);
                    setTimeout(() => setCompanyMenuAnchor(null), 0);
                  }}
                  sx={{
                    p: 1,
                    mb: 0.8,
                    borderRadius: 1.5,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    border: user.selectedUserInfo === 1
                      ? '2px solid'
                      : '1px solid',
                    borderColor: user.selectedUserInfo === 1
                      ? '#2a5298'
                      : 'grey.200',
                    backgroundColor: user.selectedUserInfo === 1
                      ? 'rgba(46, 82, 152, 0.08)'
                      : 'background.paper',
                    boxShadow: user.selectedUserInfo === 1
                      ? '0 2px 8px rgba(46, 82, 152, 0.15)'
                      : '0 1px 4px rgba(0, 0, 0, 0.04)',
                    '&:hover': {
                      transform: 'translateY(-1px)',
                      boxShadow: user.selectedUserInfo === 1
                        ? '0 3px 12px rgba(46, 82, 152, 0.25)'
                        : '0 2px 8px rgba(0, 0, 0, 0.08)',
                      borderColor: user.selectedUserInfo === 1
                        ? '#1e3c72'
                        : '#2a5298'
                    }
                  }}
                >
                  {/* Top Row: Company Info */}
                  <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                    {/* Company Icon */}
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: '50%',
                        background: user.selectedUserInfo === 1
                          ? 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)'
                          : 'linear-gradient(135deg, #f0f2f5 0%, #e1e5e9 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mr: 1.2,
                        mt: 0.2,
                        fontSize: '0.8rem',
                        fontWeight: 'bold',
                        color: user.selectedUserInfo === 1 ? 'white' : '#2a5298',
                        flexShrink: 0
                      }}
                    >
                      {user.companyName?.charAt(0)?.toUpperCase()}
                    </Box>

                    {/* Company Name - Multi-line */}
                    <Box sx={{ flex: 1, minWidth: 0, mr: 1 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: user.selectedUserInfo === 1 ? 600 : 500,
                          color: user.selectedUserInfo === 1 ? '#1e3c72' : 'text.primary',
                          fontSize: '0.8rem',
                          lineHeight: 1.3,
                          wordWrap: 'break-word',
                          hyphens: 'auto'
                        }}
                      >
                        {user.companyName}
                      </Typography>
                    </Box>

                    {/* Status Dot */}
                    <Box
                      sx={{
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        backgroundColor: user.selectedUserInfo === 1 ? '#2a5298' : '#94a3b8',
                        flexShrink: 0,
                        mt: 0.6
                      }}
                    />
                  </Box>

                  {/* Bottom Row: Status Info (only for selected) - REMOVED */}
                </Box>
              ))}
            </Box>

            {/* Quick Switch Message */}
            {users && users.length > 1 && (
              <Box
                sx={{
                  mx: 1.5,
                  mb: 1.5,
                  p: 1,
                  backgroundColor: 'info.lighter',
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'info.light'
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    color: 'info.dark',
                    fontSize: '0.65rem',
                    fontWeight: 500,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <svg
                    style={{ width: 12, height: 12, marginRight: 4 }}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zm-4 4a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                  Kurum değiştirmek için tıklayın
                </Typography>
              </Box>
            )}
          </Menu>
        </Box>

        {/* Mobile - Actions Menu */}
        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end' }}>
          <IconButton
            onClick={(e) => setMobileMenuAnchor(e.currentTarget)}
            sx={{
              color: 'text.primary'
            }}
          >
            <MoreVertIcon />
          </IconButton>

          <Menu
            anchorEl={mobileMenuAnchor}
            open={Boolean(mobileMenuAnchor)}
            onClose={() => setMobileMenuAnchor(null)}
            PaperProps={{
              sx: {
                width: 280,
                borderRadius: 3,
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)',
                border: '1px solid rgba(0, 0, 0, 0.08)',
                overflow: 'hidden'
              }
            }}
            MenuListProps={{
              sx: {
                padding: 0
              }
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            {/* User Info Section */}
            <Box
              sx={{
                p: 2,
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white'
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Avatar
                  sx={{
                    mr: 2,
                    width: 40,
                    height: 40,
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    fontSize: '1rem',
                    fontWeight: 'bold'
                  }}
                >
                  {currentUserState?.email?.[0]?.toUpperCase()}
                </Avatar>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: 'white',
                      mb: 0.5
                    }}
                  >
                    {currentUserState?.email}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'rgba(255, 255, 255, 0.8)'
                    }}
                  >
                    {currentUserState?.companyName}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Divider />

            {/* Company Switch Section */}
            <Box sx={{ p: 2 }}>
              {/* Header with fintech gradient background */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  borderRadius: 2,
                  p: 1.5,
                  mb: 2,
                  color: 'white'
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'white' }}>
                  Kurumlar
                </Typography>
                <Box
                  sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    color: 'white',
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.75rem',
                    fontWeight: 'bold',
                    backdropFilter: 'blur(10px)'
                  }}
                >
                  {users?.length}
                </Box>
              </Box>

              {/* Companies List */}
              <Box sx={{ maxHeight: 280, overflow: 'auto', pr: 0.5 }}>
                {users?.map((user, index) => (
                  <Box
                    key={user.companyId}
                    onClick={() => {
                      handleCompanySwitch(user.companyId);
                      setTimeout(() => setMobileMenuAnchor(null), 0);
                    }}
                    sx={{
                      p: 1.2,
                      mb: 1,
                      borderRadius: 2,
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      border: user.selectedUserInfo === 1
                        ? '2px solid'
                        : '1px solid',
                      borderColor: user.selectedUserInfo === 1
                        ? '#2a5298'
                        : 'grey.200',
                      backgroundColor: user.selectedUserInfo === 1
                        ? 'rgba(46, 82, 152, 0.08)'
                        : 'background.paper',
                      boxShadow: user.selectedUserInfo === 1
                        ? '0 3px 10px rgba(46, 82, 152, 0.15)'
                        : '0 2px 6px rgba(0, 0, 0, 0.04)',
                      '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: user.selectedUserInfo === 1
                          ? '0 4px 15px rgba(46, 82, 152, 0.25)'
                          : '0 3px 12px rgba(0, 0, 0, 0.08)',
                        borderColor: user.selectedUserInfo === 1
                          ? '#1e3c72'
                          : '#2a5298'
                      }
                    }}
                  >
                    {/* Top Row: Company Info */}
                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                      {/* Company Icon */}
                      <Box
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: '50%',
                          background: user.selectedUserInfo === 1
                            ? 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)'
                            : 'linear-gradient(135deg, #f0f2f5 0%, #e1e5e9 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mr: 1.2,
                          mt: 0.3,
                          fontSize: '0.8rem',
                          fontWeight: 'bold',
                          color: user.selectedUserInfo === 1 ? 'white' : '#2a5298',
                          flexShrink: 0
                        }}
                      >
                        {user.companyName?.charAt(0)?.toUpperCase()}
                      </Box>

                      {/* Company Name - Multi-line */}
                      <Box sx={{ flex: 1, minWidth: 0, mr: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: user.selectedUserInfo === 1 ? 600 : 500,
                            color: user.selectedUserInfo === 1 ? '#1e3c72' : 'text.primary',
                            fontSize: '0.82rem',
                            lineHeight: 1.2,
                            wordWrap: 'break-word',
                            hyphens: 'auto'
                          }}
                        >
                          {user.companyName}
                        </Typography>
                      </Box>

                      {/* Status Dot */}
                      <Box
                        sx={{
                          width: 6,
                          height: 6,
                          borderRadius: '50%',
                          backgroundColor: user.selectedUserInfo === 1 ? '#2a5298' : '#94a3b8',
                          flexShrink: 0,
                          mt: 0.6
                        }}
                      />
                    </Box>

                    {/* Bottom Row: Status Info (only for selected) - REMOVED */}
                  </Box>
                ))}
              </Box>

              {/* Quick Switch Message */}
              {users && users.length > 1 && (
                <Box
                  sx={{
                    mt: 2,
                    p: 1.2,
                    backgroundColor: 'rgba(46, 82, 152, 0.06)',
                    borderRadius: 1.5,
                    border: '1px solid',
                    borderColor: 'rgba(46, 82, 152, 0.2)'
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#2a5298',
                      fontSize: '0.65rem',
                      fontWeight: 500,
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <svg
                      style={{ width: 12, height: 12, marginRight: 6 }}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    Kurum değiştirmek için tıklayın
                  </Typography>
                </Box>
              )}
            </Box>

            <Divider />

            {/* Action Items */}
            <Box sx={{ py: 1 }}>
              <MenuItem
                onClick={() => {
                  setMobileMenuAnchor(null);
                  navigate('/authentication/change-pass');
                }}
                sx={{
                  px: 2,
                  py: 1.5,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                <PasswordIcon
                  sx={{
                    mr: 2,
                    color: 'primary.main',
                    fontSize: '1.1rem'
                  }}
                />
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Şifre Değiştir
                </Typography>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  setMobileMenuAnchor(null);
                  handleSignOut();
                }}
                sx={{
                  px: 2,
                  py: 1.5,
                  '&:hover': {
                    backgroundColor: 'rgba(244, 67, 54, 0.08)'
                  }
                }}
              >
                <LogoutIcon
                  sx={{
                    mr: 2,
                    color: 'error.main',
                    fontSize: '1.1rem'
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 500,
                    color: 'error.main'
                  }}
                >
                  Çıkış Yap
                </Typography>
              </MenuItem>
            </Box>
          </Menu>
        </Box>

        {/* Desktop - User Menu */}
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <Button
            onClick={(e) => setUserMenuAnchor(e.currentTarget)}
            sx={{
              borderRadius: 3,
              px: 2,
              py: 1,
              textTransform: 'none',
              backgroundColor: 'rgba(0, 0, 0, 0.02)',
              border: '1px solid rgba(0, 0, 0, 0.08)',
              minWidth: 180,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                border: '1px solid rgba(0, 0, 0, 0.12)',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
              },
              transition: 'all 0.2s ease-in-out'
            }}
            startIcon={
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  boxShadow: '0 2px 8px rgba(46, 82, 152, 0.3)'
                }}
              >
                <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </Box>
            }
            endIcon={
              <KeyboardArrowDown
                sx={{
                  transition: 'transform 0.2s ease-in-out',
                  transform: Boolean(userMenuAnchor) ? 'rotate(180deg)' : 'rotate(0deg)',
                  color: 'text.secondary'
                }}
              />
            }
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 1, flex: 1 }}>
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  fontSize: '0.7rem',
                  lineHeight: 1,
                  mb: 0.2
                }}
              >
                Kullanıcı
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  color: 'text.primary',
                  fontWeight: 500,
                  lineHeight: 1.2,
                  textAlign: 'left',
                  wordWrap: 'break-word',
                  hyphens: 'auto',
                  fontSize: '0.8rem'
                }}
              >
                {currentUserState?.email}
              </Typography>
            </Box>
          </Button>

          <Menu
            anchorEl={userMenuAnchor}
            open={Boolean(userMenuAnchor)}
            onClose={() => setUserMenuAnchor(null)}
            PaperProps={{
              sx: {
                padding: "0px !important",
                width: 320,
                borderRadius: 3,
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                border: '1px solid rgba(0, 0, 0, 0.08)',
                overflow: 'hidden'
              }
            }}
            MenuListProps={{
              sx: {
                padding: 0
              }
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            sx={{
              '& .MuiMenu-paper': {
                padding: "0px !important",
                mt: 1
              },
              '& .MuiMenu-list': {
                padding: 0
              }
            }}
          >
            {/* User Info Section */}
            <Box
              sx={{
                p: 3,
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white'
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Avatar
                  sx={{
                    mr: 2,
                    width: 48,
                    height: 48,
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    border: '2px solid rgba(255, 255, 255, 0.3)'
                  }}
                >
                  {currentUserState?.email?.[0]?.toUpperCase()}
                </Avatar>
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      color: 'white',
                      mb: 0.5,
                      fontSize: '0.9rem'
                    }}
                  >
                    {currentUserState?.email}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'rgba(255, 255, 255, 0.8)',
                      fontSize: '0.8rem'
                    }}
                  >
                    {currentUserState?.companyName}
                  </Typography>
                </Box>
              </Box>

            </Box>

            <Divider />

            {/* Menu Items */}
            <Box sx={{ py: 1 }}>
              <MenuItem
                onClick={() => {
                  navigate('/authentication/change-pass');
                }}
                sx={{
                  px: 3,
                  py: 1.5,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    transform: 'scale(1.02)',
                    transition: 'all 0.2s ease-in-out'
                  },
                  transition: 'all 0.2s ease-in-out'
                }}
              >
                <PasswordIcon
                  sx={{
                    mr: 2,
                    color: 'primary.main',
                    fontSize: '1.2rem'
                  }}
                />
                <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '0.85rem' }}>
                  Şifre Değiştir
                </Typography>
              </MenuItem>

              <MenuItem
                onClick={handleSignOut}
                sx={{
                  px: 3,
                  py: 1.5,
                  '&:hover': {
                    backgroundColor: 'rgba(244, 67, 54, 0.08)',
                    transform: 'scale(1.02)',
                    transition: 'all 0.2s ease-in-out'
                  },
                  transition: 'all 0.2s ease-in-out'
                }}
              >
                <LogoutIcon
                  sx={{
                    mr: 2,
                    color: 'error.main',
                    fontSize: '1.2rem'
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    color: 'error.main',
                    fontSize: '0.85rem'
                  }}
                >
                  Çıkış Yap
                </Typography>
              </MenuItem>
            </Box>
          </Menu>
        </Box>
      </Toolbar>
    </StyledAppBar>
  );
};

export default Header;
